module.exports = __webpack_public_path__ + "01bf956c99b8769288320d1990f740f5.pdf";